import { foundationStepperStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroStepperStyles = css `
  ${foundationStepperStyles}

  .stepper-tab {
    background-color: var(--neutral-layer-3);
  }
`;
